import React from "react";
import { useTranslation, LangType } from "./hooks/useTranslation";

interface ContactsProps {
  lang: LangType;
}

export const Contacts: React.FC<ContactsProps> = ({ lang }) => {
  const t = useTranslation(lang);
  return (
    <main className="page-container">
      <section className="contacts">
        <p className="text">{t("contactsText")}</p>
      </section>
    </main>
  );
};
